import { Injectable } from "@angular/core";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { StateModel } from "../models/state";
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Injectable({
  providedIn: "root",
})
export class StateProvider {
  state: StateModel[] = [];
  tseUsers: any[] = [];
  m2Users: any[] = [];
  m3Users: any[] = [];
  tmmUsers: any[] = [];

  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration
  ) {
    this.getStateList()
   }

  getStateList(): void {
    console.log("getstates")
    this.apiService
      .getHeaders(this.apiConfig.configGetStates)
      .subscribe((res: any) => {
        this.state = res.body.data as StateModel[];
        console.log(this.state)
        this.state.forEach((s) => {
          s.id = s.state_code;
        });
      });
  }

  getUserList(): void {
    this.apiService
      .getHeaders(this.apiConfig.getAllUsers)
      .subscribe((res: any) => {
        this.m2Users = res.body.data.m2 as any[];
        this.tseUsers = res.body.data.tse as any[];
        this.m3Users = res.body.data.m3 as any[];
        this.tmmUsers = res.body.data.tmm as any[];
        if (this.tseUsers.length > 0) {
          this.tseUsers.forEach(i => {
            i.name = i.user_detail_name + '-' + i.mobile;
            i.id = i.user_id;
          })
        }

        if (this.m2Users.length > 0) {
          this.m2Users.forEach(i => {
            i.name = i.user_detail_name + '-' + i.mobile;
            i.id = i.user_id;
          })
        }

        if (this.m3Users.length > 0) {
          this.m3Users.forEach(i => {
            i.name = i.user_detail_name + '-' + i.mobile;
            i.id = i.user_id;
          })
        }

        if (this.tmmUsers.length > 0) {
          this.tmmUsers.forEach(i => {
            i.name = i.user_detail_name + '-' + i.mobile;
            i.id = i.user_id;
          })
        }
      });
  }
}
